import React from "react";
import ItemList from "./ItemList";
import TotalPrice from "./TotalPrice";

const CartDetails = () => {
  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
      <ItemList />
      <TotalPrice />
    </div>
  );
};

export default CartDetails;
